import {createContext} from "react";

export const ModulePermissionsContext = createContext({
    moduleList: null,
    setModuleList: (val) => []
})